import gql from "graphql-tag";

export const toggleFavoriteProductMutation = gql`
  mutation toggleFavoriteProduct($productId: ID!) {
    toggleFavoriteProduct(productId: $productId)
  }
`;

export const setCatalogUiVersionMutation = gql`
  mutation setCatalogUiVersion($version: CatalogVersion!) {
    setCatalogUiVersion(version: $version) {
      id
    }
  }
`;
